import { LDEvaluationDetail } from 'launchdarkly-node-server-sdk';
import Logger from '../lib/clientLogger';

// Builds the URL - pulled it out for prettier formatting
const trackClickUrl = (memberUuid: string) => {
  return `/trackClick.do?contentType=mfeClick&contentId=${memberUuid}`;
};

const executeAPICall = async (
  memberUuid: string,
  trackClickGQLCallEvaluation: LDEvaluationDetail | undefined,
  fireClickEventGQL: (memberUuid: string) => Promise<undefined | number>
): Promise<number | undefined> => {
  if (
    typeof trackClickGQLCallEvaluation === 'undefined' ||
    trackClickGQLCallEvaluation?.value === false
  ) {
    const response = await fetch(trackClickUrl(memberUuid));
    if (!response.ok) {
      Logger.error({
        msg: 'Unexpected response status from click event API',
        'response.status': response.status,
        memberUuid,
        comeFrom: 'trackClick',
      });
    }
    return response.status;
  }
  return fireClickEventGQL(memberUuid);
};
const uuidV4Regex = /^[0-9A-F]{8}-[0-9A-F]{4}-[0-9A-F]{4}-[0-9A-F]{4}-[0-9A-F]{12}$/i;

const fireClickCall = async (
  memberUuid: string,
  logTag: string,
  trackClickGQLCallEvaluation: LDEvaluationDetail | undefined,
  fireClickEventGQL: (memberUuid: string) => Promise<undefined | number>
): Promise<number | undefined> => {
  const clickRequestStartTime = performance.now();
  const responseStatus = await executeAPICall(
    memberUuid,
    trackClickGQLCallEvaluation,
    fireClickEventGQL
  );
  const elapsed = performance.now() - clickRequestStartTime;
  Logger.info({
    tags: [logTag],
    msg: 'Finished logging post-auth click event',
    elapsed,
    comeFrom: 'trackClick',
  });
  if (responseStatus !== 204) {
    await new Promise((resolve) => setTimeout(resolve, 500));
  }
  return responseStatus;
};

const logClickEvent = async (
  memberUuid: string,
  fromApp: boolean,
  trackClickGQLCallEvaluation: LDEvaluationDetail | undefined,
  fireClickEventGQL: (memberUuid: string) => Promise<undefined | number>
) => {
  const logTag = fromApp ? '_app' : 'authCallback';
  if (memberUuid && uuidV4Regex.test(memberUuid)) {
    let latestResponseStatus: number | undefined;
    let callSuccessful = false;
    let attemptCount = 0;
    const maxAttempts = 3;
    while (!callSuccessful && attemptCount < maxAttempts) {
      /* eslint-disable no-await-in-loop */
      latestResponseStatus = await fireClickCall(
        memberUuid,
        logTag,
        trackClickGQLCallEvaluation,
        fireClickEventGQL
      );
      callSuccessful = latestResponseStatus === 204;
      attemptCount += 1;
      Logger.info({
        tags: [logTag],
        msg: 'Click event attempt',
        attemptCount,
        comeFrom: 'trackClick',
      });
    }

    if (typeof latestResponseStatus === 'undefined') {
      Logger.error({
        tags: [logTag],
        msg: 'Click event failure due to undefined response',
        memberUuid,
        comeFrom: 'trackClick',
      });
    }
  } else {
    Logger.error({
      tags: [logTag],
      msg: 'Invalid memberUuid to logClickEvent',
      memberUuid,
      comeFrom: 'trackClick',
    });
  }
};

export default logClickEvent;
